// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewport {
  position: relative;
  padding: 5vh 0 10vh;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  overflow-x: hidden;
}
.viewport .video-container {
  position: relative;
  width: 100%;
  height: 90%;
}
.viewport .video-container.video-container-attech {
  display: flex;
  align-items: center;
}
.viewport .video-container.video-container-in-sharing {
  width: 264px;
  flex-shrink: 0;
}
.viewport .video-container.single-video-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewport .video-container .single-video-wrap {
  width: 100%;
  aspect-ratio: 16/9;
  height: auto;
  position: relative;
  max-height: 100%;
}
.viewport .video-container .video-canvas {
  width: 100%;
  height: 100%;
}
.viewport .video-container .self-video {
  position: absolute;
  width: 254px;
  height: 143px;
  top: 50px;
  right: 30px;
  z-index: 2;
  display: none;
}
.viewport .video-container .self-video.single-self-video {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.viewport .video-container .self-video.self-video-show {
  display: block;
}
.viewport .video-container .ant-radio-button-wrapper {
  z-index: 1;
}
.viewport .video-container .video-container-wrap {
  flex: 1 1;
  height: 100%;
}
.viewport .video-container .user-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
}
.viewport .video-container .user-list .video-cell {
  min-width: 256px;
  aspect-ratio: 16/9;
  position: relative;
  flex: 1 1;
  margin: 12px;
}
.viewport .video-container .user-list .video-cell .change-video-resolution {
  position: absolute;
}
.viewport .video-container .user-list .video-cell .video-player {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.viewport .avatar-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  padding: 0;
  margin: 0;
}
.viewport .video-operations {
  position: absolute;
  left: 0;
  bottom: 0;
}
@media screen and (max-width: 450px) {
  .viewport .video-operations {
    bottom: 7%;
  }
}
.viewport .avatar-wrap {
  position: absolute;
  pointer-events: auto;
  list-style: none;
  top: 0;
  left: 0;
}
.viewport .avatar-wrap-dragging {
  z-index: 10;
}
.viewport .single-view-avatar {
  top: 0;
  left: 0;
}
.viewport .self-video-tag {
  display: none;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/feature/video/video.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;AAGN;AADI;EACE,YAAA;EACA,cAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAGN;AADI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAGN;AAAI;EACE,WAAA;EACA,YAAA;AAEN;AAAI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;AAEN;AADM;EACE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAGR;AADM;EACE,cAAA;AAGR;AAAI;EACE,UAAA;AAEN;AAAI;EACE,SAAA;EACA,YAAA;AAEN;AAAI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AAEN;AAAM;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAER;AADQ;EACE,kBAAA;AAGV;AADQ;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAGV;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAAJ;AAEE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;AAAJ;AAEI;EALF;IAMI,UAAA;EACJ;AACF;AACE;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,MAAA;EACA,OAAA;AACJ;AACE;EACE,aAAA;EACA,kBAAA;AACJ","sourcesContent":[".viewport {\n  position: relative;\n  padding: 5vh 0 10vh;\n  box-sizing: border-box;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  display: flex;\n  overflow-x: hidden;\n  .video-container {\n    position: relative;\n    width: 100%;\n    height: 90%;\n    &.video-container-attech {\n      display: flex;\n      align-items: center;\n    }\n    &.video-container-in-sharing {\n      width: 264px;\n      flex-shrink: 0;\n    }\n    &.single-video-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .single-video-wrap {\n      width: 100%;\n      aspect-ratio: 16/9;\n      height: auto;\n      position: relative;\n      max-height: 100%;\n    }\n\n    .video-canvas {\n      width: 100%;\n      height: 100%;\n    }\n    .self-video {\n      position: absolute;\n      width: 254px;\n      height: 143px;\n      top: 50px;\n      right: 30px;\n      z-index: 2;\n      display: none;\n      &.single-self-video {\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n      }\n      &.self-video-show {\n        display: block;\n      }\n    }\n    .ant-radio-button-wrapper {\n      z-index: 1;\n    }\n    .video-container-wrap {\n      flex: 1;\n      height: 100%;\n    }\n    .user-list {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: space-around;\n      align-items: center;\n\n      .video-cell {\n        min-width: 256px;\n        aspect-ratio: 16/9;\n        position: relative;\n        flex: 1;\n        margin: 12px;\n        .change-video-resolution {\n          position: absolute;\n        }\n        .video-player {\n          display: block;\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n        }\n      }\n    }\n  }\n  .avatar-list {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n  }\n  .video-operations {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    // Change bottom property for smaller screens\n    @media screen and (max-width: 450px) {\n      bottom: 7%; // Adjust this value as needed\n    }\n  }\n  .avatar-wrap {\n    position: absolute;\n    pointer-events: auto;\n    list-style: none;\n    top: 0;\n    left: 0;\n  }\n  .avatar-wrap-dragging {\n    z-index: 10;\n  }\n  .single-view-avatar {\n    top: 0;\n    left: 0;\n  }\n  .self-video-tag {\n    display: none;\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
